import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { IBed } from "./ibed";
import { BedService } from "./bed.service";

@Injectable({
    providedIn: 'root'
})
export class BedResolver implements Resolve<BaseRespone<{ pagination: PaginationResult, bedDetails: IBed[] }>> {
    /**
     * Constructor
     */
    constructor(private _bedService: BedService) {
    }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, bedDetails: IBed[] }>> {
        var data = {
            pageNumber: 0,
            pageSize: 100,
            roomId: Number(route.paramMap.get('roomId'))
        };
        return this._bedService.getAllBeds(data);
    }
}